/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
// @ts-ignore
import Carousel from 'carousel-react-rcdev'
// @ts-ignore
import ProductTile from './../product-tile/./product-tile';
// @ts-ignore
import ProductSpecs from './../product-detail/./specs';
// @ts-ignore
import PortalModal from './../portal-modal/./portal-modal';
//@ts-ignore
import {GetProductsBySubCategory,GetProductsByCategory, GetProductsBySlugs} from './../../themes/kent/utilities/dataFunctions';

interface IProps {
  products?:any;
  onProductClick?:any;
  showStats?:any;
  theme?:any;
  year?:any;
  active?:any;
  dismissed?:any;
  title?:any;
  categoryId?:any;
  subcategoryId?:any;
  slugList?:any;
  blockProductClick?:any;
}

interface IState {
  ready:boolean;
  products?:any;
}


/**
 *
 * Hero component
 * @extends {React.Component}
 */
class HosportsHorizontalProductScroller extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      ready:false
    };
  }

  public componentDidMount = () => {
    this.setUpScreen()
    setTimeout(
      () => {
        this.setState({
          ready:true
        });
      },
      100);
  }
  public setUpScreen = async () =>{
    let products = this.props.products;
    console.log('starting')
    if(this.props.categoryId && this.props.categoryId != ''){
      products = await GetProductsByCategory(this.props.categoryId, this.props.year)
      console.log(products)
    }
    if(this.props.subcategoryId && this.props.subcategoryId != ''){
      products = await GetProductsBySubCategory(this.props.subcategoryId, this.props.year)
      console.log(products)
    }
    if(this.props.slugList && this.props.slugList.length > 0){
      products = await GetProductsBySlugs(this.props.slugList, this.props.year)
      console.log(products)
    }
    console.log(products)
    this.setState({
      products:products
    })
  }
  public productClick = (e:any,index:any)=>{
    if(this.props.onProductClick){
      this.props.onProductClick(index)
    }
  }
  public render(): JSX.Element {
    let readyClass = this.state.ready ? 'active' : '';
    let theme = "light-theme";
    if(this.props.theme == "dark"){
      theme = "dark-theme";
    }
    return (
      <PortalModal
        modalHidden={this.props.dismissed}
        modalActive={this.props.active}
        content={
          <div className={"horizontal-product-scroller-container "+readyClass+" "+theme}>
            {this.props.title && <h1 className="product-scroller-container-title">{this.props.title}</h1>}
            <Carousel>
              {this.state.products && this.state.products.map((product:any,index:any) =>{
                if(this.props.blockProductClick){
                  return(
                    <div className="horizontal-product-scroller-tile">
                      <div onClick={(e)=>this.productClick(e,index)}>
                        <span style={{pointerEvents:'none'}}>
                          <ProductTile product={product} year={this.props.year} />
                        </span>
                        {this.props.showStats &&
                          <ProductSpecs product={product} forceBrandColor={true}  />
                        }
                      </div>
                    </div>
                  )
                } else{
                  return(
                    <div className="horizontal-product-scroller-tile">
                      <div>
                        <span>
                          <ProductTile product={product} year={this.props.year} />
                        </span>
                        {this.props.showStats &&
                          <ProductSpecs product={product} forceBrandColor={true} />
                        }
                      </div>
                    </div>
                  )
                }

              })}
            </Carousel>
          </div>
        }
      />
    );
  }
}

export default HosportsHorizontalProductScroller;
